import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'

import { getCurrentPartnerId } from 'selectors/settings'
import CustomersExport from './customers-export'

export class CustomersExportContainer extends Component {

  render() {
    return (
      <CustomersExport exportUrl={`/p/${this.props.partnerId}/data/customers/export`} />
    )
  }

}

CustomersExportContainer.propTypes = {
  partnerId: PropTypes.string,
}

const mapStateToProps = state => ({
  partnerId: getCurrentPartnerId(state),
})

export default connect(mapStateToProps)(CustomersExportContainer)



/** WEBPACK FOOTER **
 ** ./src/components/customers-export/customers-export-container.js
 **/